import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import NavActions from '../../actions';
import { getDataAttribute } from 'epic-common/src/browser';
import { downloads } from '../../constants';
import root from 'window-or-global';

@pureRender
export default class EpicGamesToggle extends React.Component {
    constructor(props) {
        super(props);
        this.listenerOn = false;
        this.keepShieldMenuOpen = false;
        this.state = {
            hoverTriangle: false
        };
    }

    static propTypes = {
        isActive: PropTypes.bool,
        epicPropertyName: PropTypes.string,
        downloadLink: PropTypes.object,
        properties: PropTypes.array,
        pcDownloadUrl: PropTypes.string,
        macDownloadUrl: PropTypes.string,
        hideShieldDownload: PropTypes.bool
    };

    static contextTypes = {
        isMobile: PropTypes.bool,
        isTablet: PropTypes.bool,
        isDesktop: PropTypes.bool,
        messages: PropTypes.object,
        globalLinkOnClick: PropTypes.func
    };


    addListener() {
        //Add a click listener anywhere on the page which will close the dropdown
        document.body.addEventListener('click', this.closeEgNav);
        this.listenerOn = true;
    }

    removeListener() {
        //remove the click listener
        document.body.removeEventListener('click', this.closeEgNav);
        this.listenerOn = false;
    }

    componentDidUpdate() {
        if (this.props.isActive && !this.listenerOn && !this.context.isDesktop) {
            this.addListener();
        }
    }

    componentWillUnmount() {
        this.removeListener();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isActive && !nextProps.isActive && this.listenerOn) {
            this.closeEgNav();
        }

        if (this.keepShieldMenuOpen && !nextProps.isActive) {
            //hovering and props have forced it closed...
            this.setActive();
        }
    }

    closeEgNav = (event) => {
        this.keepShieldMenuOpen = false;
        this.removeListener();
        setTimeout(() => {
            NavActions.egNavActive(false);
        }, 100);
    };

    setActive = () => {
        NavActions.egNavActive.defer({ isActive: true, isMobile: this.context.isMobile });
        //Reset all other clickable items
        NavActions.searchActive.defer(false);
        NavActions.tabletNavActive.defer(false);
        NavActions.mobileNavActive.defer(false);
        NavActions.mobileNavActiveLinks.defer(false);
    };

    showProperties = (event) => {
        const toggle = () => {
            if (!this.props.isActive) {
                this.setActive();
            } else {
                this.closeEgNav(event);
            }
        };

        if (event) {
            if (this.context.isDesktop && event.type === 'mouseenter') {
                this.keepShieldMenuOpen = true;
                this.setActive();
            } else if (this.context.isDesktop && event.type === 'mouseleave') {
                this.keepShieldMenuOpen = false;
                NavActions.egNavActive(false);
            } else if ((!this.context.isDesktop && event.type === 'click') || (this.context.isDesktop && event.type === 'touchend')) {
                root.scrollTo(0, 0);
                toggle();
            }
        } else {
            toggle();
        }
    };

    downloadClick = (e) => {
        const dl = this.props.downloadLink || {};
        const href = this.getDownloadUrl();
        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (dl && dl.onClick && typeof dl.onClick === 'function') {
                dl.onClick(e);
            }
        }
    };

    linkClick = (e) => {
        const index = getDataAttribute(e.currentTarget, 'index');
        const properties = this.props.properties || [];
        const href = properties[index] ? properties[index].egHref : undefined;
        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            const disabledValue = getDataAttribute(e.currentTarget, 'disabled');
            if (disabledValue === 'disabled' || disabledValue === true || disabledValue === 'true') {
                e.preventDefault();
            }
        }
    };

    mouseLeaveTriangle = () => {
        this.setState({
            hoverTriangle: false
        });
    };

    mouseEnterTriangle = () => {
        this.setState({
            hoverTriangle: true
        });
    };

    getDownloadUrl = () => {
        const downloadLink = this.props.downloadLink || {};
        const href = downloadLink.href || null;

        if (href) {
            return href;
        }
        if (root._epicGamesNav && root._epicGamesNav.browser && root._epicGamesNav.browser.mac) {
            return this.props.macDownloadUrl || downloads.macDownloadUrl;
        }
        return this.props.pcDownloadUrl || downloads.pcDownloadUrl;
    };

    render() {
        let btnClass = 'egLogo cursor-pointer';
        let active = false;
        if (this.props.isActive) {
            active = true;
            btnClass += ' active';
        }

        //properties refers to the epic games properties to be listed under the epic shield
        const properties = this.props.properties || [];

        const href = this.getDownloadUrl();
        let title = this.context.messages.default_download;
        const dl = this.props.downloadLink;
        if (dl) {
            if (dl.title) {
                title = dl.title;
            }
        }

        const array = [];

        properties.forEach((property, i) => {
            if (property.egName && !property.egSkip) {
                const current = this.props.epicPropertyName === property.propertyKey;
                array.push(
                    <li key={property.propertyKey} className={current ? 'active text-color-active' : ''}>
                        <a
                            href={property.egHref || '#'}
                            onClick={this.linkClick}
                            data-index={i}
                            data-key={property.propertyKey}
                            data-disabled={current}
                            className={current ? 'text-color-active' : 'text-color-hover text-color-dark-nonactive'}>{property.egName}</a>
                    </li>
                );
            }
        });

        return (
            <div
                role="button"
                tabIndex="0"
                id="egLogo"
                className={btnClass}
                onMouseEnter={this.showProperties}
                onMouseLeave={this.showProperties}
                onClick={this.showProperties}
                onTouchEnd={this.showProperties}>
                <div className={`shieldLogo text-color bg-color text-color-border-after ${this.state.hoverTriangle ? 'mouse-over' : ''}`} />
                <div className="shield-triangle-hover-fix" onMouseLeave={this.mouseLeaveTriangle} onMouseEnter={this.mouseEnterTriangle} />
                {!this.context.isDesktop ? <div className={`mobile-overlay ${active ? 'active' : ''}`} /> : ''}
                <div id="eg-properties" className="bg-color">
                    <ul className="property-list">
                        {array}
                    </ul>
                    {!this.props.hideShieldDownload ?
                        <ul className="download-link accent-bg-color accent-bg-color-hover">
                            <li role="menuitem" onClick={this.downloadClick}>
                                <a id="downloadLink" className="accent-text-color" href={href}>{title}</a>
                            </li>
                        </ul> : ''}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/components/epicGamesToggle/EpicGamesToggle.js